import React from 'react'
import {
  GridColDef,
  GridRenderCellParams,
  GridRowModes,
  GridActionsCellItem,
} from '@mui/x-data-grid-pro'
import { CheckCircle, Cancel } from '@mui/icons-material'
import { DataRowMenu } from './DataRowMenu'

export const ColumnsDef = (props: any) => {
  const {
    columns: gridColumns,
    deleteHandler,
    rowModesModel,
    handleSaveClick,
    handleCancelClick,
    editModeHandler,
    viewLink,
    showActionMenu,
    editAction,
    resendUserInvitationHandler,
    dataType
  } = props

  const columns: GridColDef[] = [
    ...gridColumns,
    {
      field: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      align: 'right',
      hide: !showActionMenu,
      renderCell: (params: GridRenderCellParams<any, any, any>) => {
        const isInEditMode = (
          rowModesModel[params.id] !== undefined
        )
          ? rowModesModel[params.id].mode === GridRowModes.Edit
          : false
        if (isInEditMode) {
          return [
            // @ts-ignore
            <GridActionsCellItem
              icon={<CheckCircle />}
              label="Save"
              color='secondary'
              key='save'
              onClick={() => handleSaveClick(params.id)} />,
            // @ts-ignore
            <GridActionsCellItem
              icon={<Cancel />}
              label="Cancel"
              color='secondary'
              key='cancel'
              onClick={() => handleCancelClick(params.id)} />
          ]
        } else {
          return [
            <DataRowMenu
              key={params.id}
              rowId={params.id}
              editModeHandler={editModeHandler}
              deleteHandler={deleteHandler}
              resendUserInvitationHandler={resendUserInvitationHandler}
              viewLink={viewLink}
              editAction={editAction}
              row={params.row}
              dataType={dataType}
            />
          ]
        }

      }
    }
  ]

  return columns

}